import { backboneModelProperties } from "../../decorators/backbone-properties";
import { prop } from "../../decorators/property";
import { CitationLinkModel } from "../models/citation-link-model";

@backboneModelProperties({
    defaults: {
        Links: []
    },
    relations: [
        {
            key: "Links",
            relatedModel: CitationLinkModel,
            type: Backbone.Many,
        },
        {
            key: "CitationLookupLink",
            relatedModel: CitationLinkModel,
            type: Backbone.One,
        }
    ]
})
export class CitationLinksModel extends Backbone.AssociatedModel {
    @prop() public Citation: string;
    @prop() public HasLookup: boolean;
    @prop() public CitationLookupLink: CitationLinkModel;
    @prop() public Links: Backbone.Collection<CitationLinkModel>;

    constructor(options?) {
        super(options);
        this.checkForJustisOneLinks(this.Links);
    }

    private checkForJustisOneLinks(links: Backbone.Collection<CitationLinkModel>) {
        links.forEach((link) => {
            if (link.Url && link.Url.includes("justis.com/search")) {
                link.IsJustisOneUrl = true;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/citation-links.ts